export default {
    global_screen_specs: 
		{
            logoHeight: 61,  
            headerHeight: 120, /*header height should be at least logoHeight +30 */
            viewportHeight: -1,
            viewportWidth: -1,
            workspaceHeight: -1,
            workspaceWidth:  -1,
            tocWidthPercent: 25,
            topicWidthPercent: 75,
        }
    };
